import { Toaster } from 'react-hot-toast';
import { AppRouter } from './routes/router';
import { AuthProvider } from './contexts/AuthContext';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';

const App = () => {
  return (
    <AuthProvider>
      <ErrorBoundary>
        <AppRouter />
      </ErrorBoundary>
      {/* API and other error notifications */}
      <Toaster position="top-right" containerStyle={{ zIndex: 2147483647 }} />
    </AuthProvider>
  );
}

export default App;
